import React from 'react';
import { Form, Checkbox, Input, Select } from 'antd'
import { BOLETA_DE_VENTA, FACTURA } from '../../../../common/types/tipoComprobanteType';

const InputGroup = Input.Group;
const { Option } = Select;

export default function Footer(props) {
    return (
        <div className="row">
            <div className={"col-md-9"}>
         
            </div>
       
            <div className="col-md-3 pt-10">
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Importe Honorario</label>
                        <div>{props.onGetFieldValue('sumaSubTotal').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Retención IR</label>
                        <div>{props.onGetFieldValue('sumaIgv').toFixed(2) === "-0.00" ? "0.00" : props.onGetFieldValue('sumaIgv').toFixed(2)}</div>
                    </div>
                </div>
                <div className="col text-right mb-5">
                    <div className="total-inline">
                        <label>Total Neto Recibido</label>
                        <div>{props.onGetFieldValue('sumaTotal').toFixed(2)}</div>
                    </div>
                </div>
       
           
            </div>
        </div>
    );
}